<template>
  <div>
    <el-row class="cs-auen-courseSelector-container" v-if="!isReadonly">
      <el-col>
        <el-select filterable class="cs-auen-courseSelector" v-model="selectedCourseId" @change="onCourseChange" placeholder="请选择或搜索课程">
          <el-option v-for="(item, index) in courseItemList" :key="index"
            :label="getCourseItemLabel(item)" :value="item.Id" />
        </el-select>
        <el-button class="margin-left-20px" type="primary" size="medium" @click="addCourse()"><i class="el-icon el-icon-plus"></i>添加</el-button>
      </el-col>
    </el-row>
    <el-row class="cs-auen-step1-courseList">
      <el-col>
        <courseList :isReadonly="isReadonly" :dataIn="courseListData" @delete="onDeleteCourse" />
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-auen-courseSelector-container {
  margin-top: 1rem;

  .cs-auen-courseSelector {
    min-width: 500px;
  }
}
.cs-auen-step1-courseList {
  margin-top: 1rem;
}
</style>

<script>
import courseList from "./courseList";
import { CourseListEx } from "./courseListEx";
import { getYearCourseType } from "@/config/mUtils.js";
import {
  getCourseData
} from "@/service/enrollmentFee.service";

const mixin_generalMethods = {
  methods: {
    getCourseItemLabel(courseItem) {
      let value = `${courseItem.CourseName}`;
      
      if (courseItem.IsYearCourse){
        value = `${value}(年课)`;
      }

      if (!courseItem.ProfessorName)
        return value;

      return `${value}, 教授: ${courseItem.ProfessorName}`;
    }
  }
};

export default {
  mixins: [mixin_generalMethods],
  props: {
    isReadonly: Boolean,
    dataIn: {
      studentId: Number,
      workflowId: Number,
      totalCourseList: Object,
      courseList: Object,
    },
  },
  data() {
    return {
      yearCourseTypeAllList:[],
      selectedCourseId: null,
      courseListData: {
        courseList: new CourseListEx([]),
      },
      //selectedCourseData: [],
    };
  },
  components: {
    courseList,
  },
  computed: {
    courseItemList() {
      if (!this.dataIn.totalCourseList ||
        !this.dataIn.courseList || !this.dataIn.courseList.data) return [];

      let itemList = this.dataIn.totalCourseList.filter(
        (item) =>
          !this.dataIn.courseList.data.contains(
            item.Id,
            (item2, value) => item2.CourseId === value
          )
      );
      return itemList;
    },
  },
  created() {
    this.yearCourseTypeAllList = getYearCourseType();
    this.init();
  },
  methods: {
    init() {
      if (
        this.dataIn &&
        this.dataIn.totalCourseList &&
        this.dataIn.courseList
      ) {
        this.courseListData = {
          courseList: this.dataIn.courseList
        }
        //this.getSelectedCourseData();
      }
    },
    // getSelectedCourseData() {
    //   if (this.dataIn && this.dataIn.selectedCourseIdList) {
    //     this.selectedCourseData = this.dataIn.totalCourseList.filter((item) =>
    //       this.dataIn.selectedCourseIdList.contains(item.Id)
    //     );
    //   } else {
    //     this.selectedCourseData = [];
    //   }
    // },
    onCourseCodeChange() {
      this.selectedCourseId = null;
    },
    onCourseChange() {},
    addCourse() {
      let course = this.dataIn.totalCourseList.find(
        (item) => item.Id == this.selectedCourseId
      );
      if (!course) {
        this.$message.warning("请选择课程");
        return;
      }

      if (
        this.dataIn.courseList.data.contains(
          course.Id,
          (item, value) => item.CourseId === value
        )
      ) {
        this.$message.warning(`课程${course.CourseName}已添加`);
        return;
      }
      let courseData = getCourseData(this.dataIn.totalCourseList, this.yearCourseTypeAllList, this.selectedCourseId);
      this.dataIn.courseList.data.push(courseData);
     
      this.selectedCourseId = null;
      this.$emit("edit");
    },
    onDeleteCourse(id) {
      this.dataIn.courseList.data.remove(id, (arr, id) => {
        let index = arr.findIndex((item) => item.Id == id);
        if (index < 0) return;
        arr.splice(index, 1);
      });
     
      this.$emit("edit");
    },
  },
  watch: {
    dataIn: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/autonomousEnrolment/workflow/step1.vue